import React from 'react';
import Slider from 'rc-slider';

const DifferentialSlider = ({handleClick, origin, ...sliderProps}) => {
    const handleRender = (node, props) => {
        const onClick = () => {
            handleClick(props.value);
        };

        let className = 'center-handle';
        if (props.value > origin) {
            className = 'right-handle';
        } else if (props.value < origin) {
            className = 'left-handle';
        }

        return (
            // eslint-disable-next-line react/jsx-no-bind
            <div className={className} onMouseUp={onClick} onTouchEnd={onClick}>
                {node}
            </div>
        );
    };

    // eslint-disable-next-line react/jsx-no-bind
    return <Slider range={true} handleRender={handleRender} {...sliderProps} />;
};

export default DifferentialSlider;
